var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ring-container"},[_c('div',{staticClass:"ringring"}),_c('div',{staticClass:"circle"}),_c('div',{staticClass:"pulsating-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }